import { Button } from "@veritrellis/ui";
import { ArrowRight, Lock } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import { AuthShell } from "../components/auth/AuthShell.js";

const sanitizeNextPath = (raw: string | null): string => {
  if (raw === null || raw.length === 0) {
    return "/";
  }
  if (!raw.startsWith("/") || raw.startsWith("//")) {
    return "/";
  }
  return raw;
};

const formatReturnPath = (path: string): string => {
  if (path === "/" || path === "/dashboard") {
    return "the dashboard";
  }
  if (path.startsWith("/settings")) {
    return `settings (${path})`;
  }
  return path;
};

export const SignInPage = () => {
  const [params] = useSearchParams();
  const next = sanitizeNextPath(params.get("next"));
  const authHref = `/auth/sign-in?return_to=${encodeURIComponent(next)}`;
  const showReturnHint = next !== "/" && next !== "/dashboard";

  return (
    <AuthShell
      title="Sign in"
      description="Use your organization SSO account. We never store passwords in the admin app."
      footer={
        <>
          Signed in as the wrong account? <a href="/auth/logout">Sign out and switch</a>
        </>
      }
    >
      <div className="admin-auth-card-body">
        {showReturnHint ? (
          <p className="admin-auth-return-hint">
            After sign-in you&apos;ll return to <code>{formatReturnPath(next)}</code>.
          </p>
        ) : null}

        <Button asChild className="w-full" size="lg">
          <a
            href={authHref}
            style={{ display: "flex", width: "100%", alignItems: "center", gap: "0.5rem" }}
          >
            <Lock className="h-4 w-4 shrink-0" />
            <span style={{ flex: 1, textAlign: "center" }}>Continue with SSO</span>
            <ArrowRight className="h-4 w-4 shrink-0" />
          </a>
        </Button>

        <p
          className="admin-auth-description"
          style={{ marginTop: "1rem", marginBottom: 0, textAlign: "center" }}
        >
          You&apos;ll be redirected to your identity provider (WorkOS).
        </p>

        <p
          className="admin-auth-description"
          style={{ marginTop: "0.5rem", marginBottom: 0, textAlign: "center" }}
        >
          Forgot your password? Passwords and resets are handled by your identity provider —{" "}
          <a href={authHref}>continue to sign-in</a> and reset there.
        </p>
      </div>
    </AuthShell>
  );
};
